/*
  Add here your own custom javascript codes
*/

(() => {
  const INDEX_BODY_CLASS = 'page-type-index';
  const PRODUCT_BODY_CLASS = 'page-type-product';
  const COLLECTION_BODY_CLASS = 'page-type-collection';
  const PAGE_BODY_CLASS = 'page-type-page';
  const READY_CLASS = 'mecha-motion-ready';
  const PRODUCT_READY_CLASS = 'product-motion-ready';
  const COLLECTION_READY_CLASS = 'collection-motion-ready';
  const ABOUT_READY_CLASS = 'about-motion-ready';
  const HELP_READY_CLASS = 'help-motion-ready';
  const VISIBLE_CLASS = 'is-visible';
  const MOTION_ATTR = 'data-mecha-motion';
  const PDP_MOTION_ATTR = 'data-luo-pdp-motion';
  const PDP_SCAN_ATTR = 'data-luo-pdp-scan';
  const COLLECTION_MOTION_ATTR = 'data-luo-collection-motion';
  const COLLECTION_SCAN_ATTR = 'data-luo-collection-scan';
  const ABOUT_MOTION_ATTR = 'data-luo-about-motion';
  const ABOUT_SCAN_ATTR = 'data-luo-about-scan';
  const HELP_MOTION_ATTR = 'data-luo-help-motion';
  const HELP_SCAN_ATTR = 'data-luo-help-scan';
  const SCAN_ATTR = 'data-luo-scan';
  const PARALLAX_ATTR = 'data-luo-parallax';
  const UI_READY_CLASS = 'mecha-ui-motion-ready';
  const PANEL_ITEM_ATTR = 'data-luo-panel-item';
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const desktopQuery = window.matchMedia('(min-width: 990px)');

  const revealTargets = [
    { selector: '[data-mecha-products] [class*="mecha-products__header-"]', scan: true, y: '30px' },
    { selector: '[data-mecha-products] [class*="mecha-products__actions-"]', y: '20px' },
    { selector: '[data-mecha-products] [data-mecha-card]', y: '34px', scale: '0.985', stagger: 45 },
    { selector: '[class*="mecha-new-items__kicker-"]', x: '-28px', y: '10px' },
    { selector: '[class*="mecha-new-items__intro-"]', x: '-34px', scan: true },
    { selector: '[class*="mecha-whats__content-"]', x: '-42px', scan: true },
    { selector: '[class*="mecha-whats__media-"]', x: '42px', y: '8px', parallax: 18 },
    { selector: '.mecha-podcast__kicker', x: '-24px', y: '8px' },
    { selector: '.mecha-podcast__heading-row', x: '-30px', scan: true },
    { selector: '.mecha-podcast__main > *', y: '32px', scale: '0.99', stagger: 60 },
    { selector: '[data-mecha-community] .mecha-community__header', x: '-34px', scan: true },
    { selector: '[data-mecha-community] .mecha-community__body', x: '34px', y: '10px', parallax: 10 },
    { selector: '[class*="mecha-newsletter__media-"]', x: '-36px', y: '8px', parallax: 16 },
    { selector: '[class*="mecha-newsletter__content-"]', x: '36px', y: '8px', scan: true }
  ];

  const parallaxSelectors = [
    { selector: '[class*="mecha-whats__media-"]', strength: 18 },
    { selector: '.mecha-podcast__main', strength: 12 },
    { selector: '[data-mecha-community] .mecha-community__body', strength: 10 },
    { selector: '[class*="mecha-newsletter__media-"]', strength: 16 }
  ];

  const productRevealTargets = [
    { selector: '.product-main .mecha-pdp__grid > .col-desktop-9:first-child', y: '10px', scale: '0.995' },
    { selector: '.product-main [id^="product-inner-"]', x: '38px', y: '12px', scan: true },
    { selector: '.product-main [id^="product-inner-"] form > :not(input[type="hidden"])', x: '30px', y: '12px', stagger: 42 },
    { selector: '.product-main .mecha-pdp__share', y: '18px' },
    { selector: '.mecha-process__eyebrow, .mecha-lockon__eyebrow, .mecha-explore__eyebrow', x: '-24px', y: '8px' },
    { selector: '.mecha-process__heading, .mecha-lockon__heading, .mecha-explore__heading', x: '-34px', scan: true },
    { selector: '.mecha-lockon__kicker, .mecha-lockon__text, .mecha-explore__description', y: '22px' },
    { selector: '.mecha-process__timeline', y: '24px', scan: true },
    { selector: '.mecha-process__date, .mecha-process__label, .mecha-process__dot', y: '16px', stagger: 70 },
    { selector: '.mecha-lockon__card', y: '36px', scale: '0.985', stagger: 85, parallax: 10 },
    { selector: '.mecha-specs__tabs', x: '-26px', y: '10px' },
    { selector: '.mecha-specs__content', x: '-34px', scan: true },
    { selector: '.mecha-specs__figure:not([hidden])', x: '40px', y: '8px', scale: '0.985', parallax: 12 },
    { selector: '.mecha-video-pdp__frame', y: '34px', scale: '0.99', scan: true, parallax: 10 },
    { selector: '.mecha-explore__carousel', y: '28px', scan: true },
    { selector: '.mecha-explore__card', y: '34px', scale: '0.985', stagger: 50 }
  ];

  const collectionRevealTargets = [
    { selector: '.mecha-collection-head__eyebrow', x: '-24px', y: '8px' },
    { selector: '.mecha-collection-head__title', x: '-38px', y: '8px', scan: true },
    { selector: '.mecha-collection-head__copy', x: '34px', y: '10px' },
    { selector: '.mecha-collection-head__filter', y: '18px', stagger: 42 },
    { selector: '.mecha-collection-grid__list', y: '20px', scan: true },
    { selector: '.mecha-collection-card', y: '30px', scale: '0.988', stagger: 38 },
    { selector: '.mecha-collection-grid__pagination', y: '22px' },
    { selector: '.service-assurance__item', y: '24px', stagger: 55 }
  ];

  const aboutRevealTargets = [
    { selector: '.mecha-collection-head__eyebrow', x: '-24px', y: '8px' },
    { selector: '.mecha-collection-head__title', x: '-38px', y: '8px', scan: true },
    { selector: '.mecha-collection-head__copy', x: '34px', y: '10px', scan: true },
    { selector: '.mecha-about-video__media', y: '26px', scale: '0.992', scan: true },
    { selector: '.mecha-about-series:not(.mecha-about-series--image-first) .mecha-about-series__copy', x: '-36px', y: '8px', scan: true },
    { selector: '.mecha-about-series--image-first .mecha-about-series__copy', x: '36px', y: '8px', scan: true },
    { selector: '.mecha-about-series:not(.mecha-about-series--image-first) .mecha-about-series__visual', x: '36px', y: '10px', parallax: 10 },
    { selector: '.mecha-about-series--image-first .mecha-about-series__visual', x: '-36px', y: '10px', parallax: 10 },
    { selector: '.mecha-about-series__buttons > *', y: '14px', stagger: 45 },
    { selector: '.mecha-about-story__art', x: '-42px', y: '8px', parallax: 12 },
    { selector: '.mecha-about-story__title-wrap', x: '34px' },
    { selector: '.mecha-about-story__copy', x: '34px', y: '16px' }
  ];

  const helpRevealTargets = [
    { selector: '.mecha-collection-head__eyebrow', x: '-24px', y: '8px' },
    { selector: '.mecha-collection-head__title', x: '-38px', y: '8px', scan: true },
    { selector: '.mecha-collection-head__copy', x: '34px', y: '10px' },
    { selector: '.mecha-help-search__header', x: '-30px', y: '8px', scan: true },
    { selector: '.mecha-help-search__form', y: '24px', scan: true },
    { selector: '.mecha-help-categories__header', x: '-30px', y: '8px', scan: true },
    { selector: '.mecha-help-category', y: '30px', scale: '0.988', stagger: 54 },
    { selector: '.mecha-help-faq__header', x: '-30px', y: '8px', scan: true },
    { selector: '.mecha-help-faq__item', y: '22px', stagger: 42 },
    { selector: '.mecha-help-contact__header', x: '-32px', y: '8px', scan: true },
    { selector: '.mecha-help-contact__form-column', x: '-34px', y: '10px' },
    { selector: '.mecha-help-contact__details', x: '34px', y: '10px' }
  ];

  let observer = null;
  let parallaxFrame = null;
  let panelListenersReady = false;

  function isIndexPage() {
    return document.body?.classList.contains(INDEX_BODY_CLASS);
  }

  function isProductPage() {
    return document.body?.classList.contains(PRODUCT_BODY_CLASS);
  }

  function isCollectionPage() {
    return document.body?.classList.contains(COLLECTION_BODY_CLASS);
  }

  function isAboutPage() {
    return document.body?.classList.contains(PAGE_BODY_CLASS) && Boolean(document.querySelector('[data-mecha-about-video], .mecha-about-story'));
  }

  function isHelpPage() {
    return document.body?.classList.contains(PAGE_BODY_CLASS) && Boolean(document.querySelector('.mecha-help-search, .mecha-help-categories, [data-mecha-help-faq], .mecha-help-contact'));
  }

  function markRevealTargets(root = document) {
    if (!isIndexPage()) return [];

    const targets = [];
    revealTargets.forEach((target) => {
      root.querySelectorAll(target.selector).forEach((element, index) => {
        if (element.hasAttribute(MOTION_ATTR)) return;
        element.setAttribute(MOTION_ATTR, '');
        element.style.setProperty('--luo-reveal-x', target.x || '0');
        element.style.setProperty('--luo-reveal-y', target.y || '24px');
        element.style.setProperty('--luo-reveal-scale', target.scale || '1');
        element.style.setProperty('--luo-reveal-delay', `${Math.min(index * (target.stagger || 55), 260)}ms`);
        if (target.scan) element.setAttribute(SCAN_ATTR, '');
        targets.push(element);
      });
    });

    return targets;
  }

  function markParallaxTargets(root = document) {
    parallaxSelectors.forEach((target) => {
      root.querySelectorAll(target.selector).forEach((element) => {
        if (element.hasAttribute(PARALLAX_ATTR)) return;
        element.setAttribute(PARALLAX_ATTR, '');
        element.dataset.luoParallaxStrength = String(target.strength);
      });
    });
  }

  function updateParallax() {
    parallaxFrame = null;

    if ((!isIndexPage() && !isProductPage() && !isCollectionPage() && !isAboutPage() && !isHelpPage()) || reduceMotion.matches || !desktopQuery.matches) {
      document.querySelectorAll(`[${PARALLAX_ATTR}]`).forEach((element) => {
        element.style.removeProperty('--luo-parallax-y');
      });
      return;
    }

    const viewportCenter = window.innerHeight / 2;
    document.querySelectorAll(`[${PARALLAX_ATTR}]`).forEach((element) => {
      const rect = element.getBoundingClientRect();
      if (rect.bottom < -120 || rect.top > window.innerHeight + 120) return;
      const strength = Number(element.dataset.luoParallaxStrength || 12);
      const elementCenter = rect.top + rect.height / 2;
      const progress = (viewportCenter - elementCenter) / window.innerHeight;
      const y = Math.max(-strength, Math.min(strength, progress * strength));
      element.style.setProperty('--luo-parallax-y', `${y.toFixed(2)}px`);
    });
  }

  function requestParallaxUpdate() {
    if (parallaxFrame) return;
    parallaxFrame = window.requestAnimationFrame(updateParallax);
  }

  function revealNow(elements) {
    elements.forEach((element) => element.classList.add(VISIBLE_CLASS));
  }

  function observeTargets(elements) {
    if (!elements.length) return;

    if (reduceMotion.matches || !('IntersectionObserver' in window)) {
      revealNow(elements);
      return;
    }

    if (!observer) {
      observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add(VISIBLE_CLASS);
          observer.unobserve(entry.target);
        });
      }, {
        rootMargin: '0px 0px -12% 0px',
        threshold: 0.16
      });
    }

    elements.forEach((element) => observer.observe(element));
  }

  function initMechaMotion(root = document) {
    if (!isIndexPage()) return;

    document.body.classList.add(READY_CLASS);
    const targets = markRevealTargets(root);
    markParallaxTargets(root);
    observeTargets(targets);
    requestParallaxUpdate();
  }

  function markProductTargets(root = document) {
    if (!isProductPage()) return [];

    const targets = [];
    productRevealTargets.forEach((target) => {
      root.querySelectorAll(target.selector).forEach((element, index) => {
        if (element.hasAttribute(PDP_MOTION_ATTR)) return;
        element.setAttribute(PDP_MOTION_ATTR, '');
        element.style.setProperty('--luo-pdp-reveal-x', target.x || '0');
        element.style.setProperty('--luo-pdp-reveal-y', target.y || '24px');
        element.style.setProperty('--luo-pdp-reveal-scale', target.scale || '1');
        element.style.setProperty('--luo-pdp-reveal-delay', `${Math.min(index * (target.stagger || 55), 340)}ms`);
        if (target.scan) element.setAttribute(PDP_SCAN_ATTR, '');
        if (target.parallax) {
          element.setAttribute(PARALLAX_ATTR, '');
          element.dataset.luoParallaxStrength = String(target.parallax);
        }
        targets.push(element);
      });
    });

    return targets;
  }

  function initProductMotion(root = document) {
    if (!isProductPage()) return;

    document.body.classList.add(PRODUCT_READY_CLASS);
    const targets = markProductTargets(root);
    observeTargets(targets);
    requestParallaxUpdate();
  }

  function markCollectionTargets(root = document) {
    if (!isCollectionPage()) return [];

    const targets = [];
    collectionRevealTargets.forEach((target) => {
      root.querySelectorAll(target.selector).forEach((element, index) => {
        if (element.hasAttribute(COLLECTION_MOTION_ATTR)) return;
        element.setAttribute(COLLECTION_MOTION_ATTR, '');
        element.style.setProperty('--luo-collection-reveal-x', target.x || '0');
        element.style.setProperty('--luo-collection-reveal-y', target.y || '24px');
        element.style.setProperty('--luo-collection-reveal-scale', target.scale || '1');
        element.style.setProperty('--luo-collection-reveal-delay', `${Math.min((index % 8) * (target.stagger || 50), 260)}ms`);
        if (target.scan) element.setAttribute(COLLECTION_SCAN_ATTR, '');
        targets.push(element);
      });
    });

    return targets;
  }

  function initCollectionMotion(root = document) {
    if (!isCollectionPage()) return;

    document.body.classList.add(COLLECTION_READY_CLASS);
    const targets = markCollectionTargets(root);
    observeTargets(targets);
    requestParallaxUpdate();
  }

  function markAboutTargets(root = document) {
    if (!isAboutPage()) return [];

    const targets = [];
    aboutRevealTargets.forEach((target) => {
      root.querySelectorAll(target.selector).forEach((element, index) => {
        if (element.hasAttribute(ABOUT_MOTION_ATTR)) return;
        element.setAttribute(ABOUT_MOTION_ATTR, '');
        element.style.setProperty('--luo-about-reveal-x', target.x || '0');
        element.style.setProperty('--luo-about-reveal-y', target.y || '24px');
        element.style.setProperty('--luo-about-reveal-scale', target.scale || '1');
        element.style.setProperty('--luo-about-reveal-delay', `${Math.min(index * (target.stagger || 55), 280)}ms`);
        if (target.scan) element.setAttribute(ABOUT_SCAN_ATTR, '');
        if (target.parallax) {
          element.setAttribute(PARALLAX_ATTR, '');
          element.dataset.luoParallaxStrength = String(target.parallax);
        }
        targets.push(element);
      });
    });

    return targets;
  }

  function initAboutMotion(root = document) {
    if (!isAboutPage()) return;

    document.body.classList.add(ABOUT_READY_CLASS);
    const targets = markAboutTargets(root);
    observeTargets(targets);
    requestParallaxUpdate();
  }

  function markHelpTargets(root = document) {
    if (!isHelpPage()) return [];

    const targets = [];
    helpRevealTargets.forEach((target) => {
      root.querySelectorAll(target.selector).forEach((element, index) => {
        if (element.hasAttribute(HELP_MOTION_ATTR)) return;
        element.setAttribute(HELP_MOTION_ATTR, '');
        element.style.setProperty('--luo-help-reveal-x', target.x || '0');
        element.style.setProperty('--luo-help-reveal-y', target.y || '24px');
        element.style.setProperty('--luo-help-reveal-scale', target.scale || '1');
        element.style.setProperty('--luo-help-reveal-delay', `${Math.min(index * (target.stagger || 55), 280)}ms`);
        if (target.scan) element.setAttribute(HELP_SCAN_ATTR, '');
        if (target.parallax) {
          element.setAttribute(PARALLAX_ATTR, '');
          element.dataset.luoParallaxStrength = String(target.parallax);
        }
        targets.push(element);
      });
    });

    return targets;
  }

  function initHelpMotion(root = document) {
    if (!isHelpPage()) return;

    document.body.classList.add(HELP_READY_CLASS);
    const targets = markHelpTargets(root);
    observeTargets(targets);
    requestParallaxUpdate();
  }

  function refreshReducedMotion() {
    if (!isIndexPage() && !isProductPage() && !isCollectionPage() && !isAboutPage() && !isHelpPage()) return;
    if (reduceMotion.matches) {
      document.querySelectorAll(`[${MOTION_ATTR}], [${PDP_MOTION_ATTR}], [${COLLECTION_MOTION_ATTR}], [${ABOUT_MOTION_ATTR}], [${HELP_MOTION_ATTR}]`).forEach((element) => {
        element.classList.add(VISIBLE_CLASS);
      });
      document.querySelectorAll(`[${PARALLAX_ATTR}]`).forEach((element) => {
        element.style.removeProperty('--luo-parallax-y');
      });
    } else {
      requestParallaxUpdate();
    }
  }

  function markPanelItems(panel) {
    const selectors = [
      '.offcanvas-header > *',
      '.offcanvas-body > *',
      '.offcanvas-footer > *',
      '.mecha-mobile-menu__header > *',
      '.mecha-mobile-menu .nav > .nav-item',
      '.mecha-mobile-menu .dropdown-item',
      '.mecha-search-drawer__field',
      '#predictive-search > *',
      '.cart-item',
      '.cart-footer > *'
    ];
    const seen = new Set();
    const items = [];

    selectors.forEach((selector) => {
      panel.querySelectorAll(selector).forEach((element) => {
        if (seen.has(element)) return;
        seen.add(element);
        items.push(element);
      });
    });

    items.forEach((element, index) => {
      element.setAttribute(PANEL_ITEM_ATTR, '');
      element.style.setProperty('--luo-panel-delay', `${Math.min(index * 42, 300)}ms`);
      element.style.setProperty('--luo-panel-x', panel.id === 'offcanvas-menu' ? '-18px' : '18px');
      element.style.setProperty('--luo-panel-y', '14px');
    });
  }

  function initPanelMotion(root = document) {
    document.body.classList.add(UI_READY_CLASS);

    root.querySelectorAll?.('#offcanvas-search, #offcanvas-cart, #offcanvas-menu').forEach((panel) => {
      markPanelItems(panel);
    });

    if (panelListenersReady) return;
    panelListenersReady = true;

    document.addEventListener('show.bs.offcanvas', (event) => {
      const panel = event.target;
      if (!panel?.matches?.('#offcanvas-search, #offcanvas-cart, #offcanvas-menu')) return;
      markPanelItems(panel);
      if (reduceMotion.matches) return;
      panel.classList.remove('mecha-panel-entering');
      void panel.offsetWidth;
      panel.classList.add('mecha-panel-entering');
    });

    document.addEventListener('shown.bs.offcanvas', (event) => {
      const panel = event.target;
      if (!panel?.matches?.('#offcanvas-search, #offcanvas-cart, #offcanvas-menu')) return;
      window.setTimeout(() => {
        panel.classList.remove('mecha-panel-entering');
      }, 680);
    });

    document.addEventListener('hidden.bs.offcanvas', (event) => {
      const panel = event.target;
      if (!panel?.matches?.('#offcanvas-search, #offcanvas-cart, #offcanvas-menu')) return;
      panel.classList.remove('mecha-panel-entering');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initPanelMotion();
      initMechaMotion();
      initProductMotion();
      initCollectionMotion();
      initAboutMotion();
      initHelpMotion();
    }, { once: true });
  } else {
    initPanelMotion();
    initMechaMotion();
    initProductMotion();
    initCollectionMotion();
    initAboutMotion();
    initHelpMotion();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initPanelMotion(event.target);
    initMechaMotion(event.target);
    initProductMotion(event.target);
    initCollectionMotion(event.target);
    initAboutMotion(event.target);
    initHelpMotion(event.target);
  });

  window.addEventListener('kt.collection.loaded', () => {
    initCollectionMotion();
  });

  window.addEventListener('scroll', requestParallaxUpdate, { passive: true });
  window.addEventListener('resize', requestParallaxUpdate);
  reduceMotion.addEventListener?.('change', refreshReducedMotion);
  desktopQuery.addEventListener?.('change', requestParallaxUpdate);
})();
